// frontend/packages/business-console/src/pages/Logout.js

import React, { useEffect, useRef } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      const ok = window.confirm("Do you want to logout?");
      if (!ok) {
        navigate(-1);
        return;
      }

      // AuthContext handles clearing storage + calling backend logout + MSAL logoutRedirect
      await logout();
    };

    run().catch(() => {
      // If anything goes sideways, send them to login.
      navigate("/login", { replace: true });
    });
  }, [logout, navigate]);

  return (
    <Box sx={{ minHeight: "50vh", display: "grid", placeItems: "center", p: 3 }}>
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2, opacity: 0.75 }}>
          Signing you out…
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(Logout);